var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " flex-wrap",
    staticStyle: {
      "display": "flex"
    }
  }, [_vm._l((_vm.imgs), function(item, index) {
    return [(_vm.showImg(item)) ? _c('div', {
      key: index,
      staticClass: "upload-warp"
    }, [_c('img', {
      staticClass: "hover imgs",
      attrs: {
        "src": item.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "del-mask"
    }, [_c('div', {
      staticClass: "icons"
    }, [_c('Icon', {
      attrs: {
        "type": "md-eye",
        "size": "18",
        "color": "#fff"
      },
      on: {
        "click": function($event) {
          return _vm.handlePreview(item.url)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-trash",
        "size": "18",
        "color": "#fff"
      },
      on: {
        "click": function($event) {
          return _vm.handleDelImg(index)
        }
      }
    })], 1)]), _vm._v(" "), (item.jigou) ? _c('span', {
      staticClass: "og-name"
    }, [_vm._v(_vm._s(item.jigou.name))]) : _vm._e()]) : _vm._e()]
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "footerHide": "",
      "width": "850px",
      "title": "图片预览"
    },
    model: {
      value: (_vm.showPreview),
      callback: function($$v) {
        _vm.showPreview = $$v
      },
      expression: "showPreview"
    }
  }, [_c('img', {
    staticClass: "pre-img",
    attrs: {
      "src": _vm.previewImg
    }
  })])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a8b511c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ImgUpload/index.vue
// module id = bChe
// module chunks = 142